import { Controller } from '@hotwired/stimulus'

// Homepage-only interactions: module tabs, FAQ accordion.
// Shared nav/drawer lives in `fos_nav_controller`. Scroll reveal lives in
// `fos_reveal_controller`. Billing toggle lives in `fos_plans_controller`.
export default class extends Controller {
  static targets = [
    'modTab', 'modPanel',
    'faqItem'
  ]

  // ── Module tabs ──

  showMod ({ currentTarget }) {
    const index = Number(currentTarget.dataset.index)

    this.modTabTargets.forEach(t => t.classList.remove('active'))
    this.modPanelTargets.forEach(p => p.classList.remove('active'))

    currentTarget.classList.add('active')
    const panel = this.modPanelTargets[index]
    if (!panel) return

    panel.classList.add('active')
    if (window.innerWidth <= 768) {
      setTimeout(() => panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 100)
    }
  }

  // ── FAQ accordion ──

  toggleFaq ({ currentTarget }) {
    const item = currentTarget.closest('[data-homepage-target="faqItem"]')
    const wasOpen = item.classList.contains('open')

    this.faqItemTargets.forEach(i => i.classList.remove('open'))
    if (!wasOpen) item.classList.add('open')
  }
}
